export default __webpack_public_path__ + "static/media/MDV__Silver1.4338aac0.png";